import { lazy, Suspense } from 'react';

const VerifyEmailForm = lazy(() =>
  import('@repo/ui/components/containers/login/verify-email-form').then((mod) => ({ default: mod.default })),
);

export default function VerifyEmailPage() {
  return (
    <Suspense fallback={<div className="flex items-center justify-center h-screen">Loading...</div>}>
      <VerifyEmailForm />
    </Suspense>
  );
}

